import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgHourglass = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.266 16.5a.61.61 0 0 0 .609-.61v-.406a.61.61 0 0 0-.61-.609c0-2.31-1.295-4.259-3.068-4.875 1.773-.616 3.069-2.565 3.069-4.875a.61.61 0 0 0 .609-.61V4.11a.61.61 0 0 0-.61-.609h-8.53a.61.61 0 0 0-.61.61v.406c0 .336.273.609.61.609 0 2.31 1.295 4.259 3.068 4.875-1.773.616-3.069 2.565-3.069 4.875a.61.61 0 0 0-.609.61v.406c0 .336.273.609.61.609h8.53ZM12.36 6.75H7.64a4.764 4.764 0 0 1-.28-1.625h5.28c0 .579-.1 1.132-.28 1.625Zm-4.72 6.5h4.72c-.434-1.188-1.323-2.031-2.36-2.031s-1.926.843-2.36 2.031Z"
        fill="#686F7D"
      />
    </svg>
  );
};
export default SvgHourglass;
